import { Check } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import { PasswordInput } from '@my2n/react-hook-form-inputs';
import { FormProvider } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { FilledInfoBar } from '../../../../components/_DesignSystemWrappers/InfoBar/FilledInfoBar';
import messages from './messages';
import { useNewPasswordForm } from './useNewPasswordForm';
import { FormFieldNames } from './validationScheme';

export interface INewPasswordFormProps {
  onSuccess: () => void;
  onRecoveryProcessRestart: () => void;
}

export function NewPasswordForm({ onRecoveryProcessRestart, onSuccess }: INewPasswordFormProps) {
  const { formData, isOryApiFetching, isPasswordHelperTextVisible, onFormSubmit } = useNewPasswordForm({
    onRecoveryProcessRestart,
    onSuccess,
  });

  return (
    <FormProvider {...formData}>
      <form onSubmit={formData.handleSubmit(onFormSubmit)}>
        <Stack spacing={1}>
          <PasswordInput
            id="new-password"
            label={<FormattedMessage {...messages.ImsNewPasswordInputLabel} />}
            name={FormFieldNames.Password}
            required
            fullWidth
            autoFocus
            helperText={isPasswordHelperTextVisible && <FormattedMessage {...messages.ImsNewPasswordInputHelperText} />}
          />
          <FilledInfoBar>
            <Typography>
              <FormattedMessage {...messages.ImsNewPasswordAlertBody} />
            </Typography>
          </FilledInfoBar>
        </Stack>
        <Button
          color="primary"
          disabled={!formData.formState.isValid || isOryApiFetching}
          fullWidth
          size="large"
          startIcon={<Check />}
          sx={{ mt: 3 }}
          type="submit"
          variant="contained"
        >
          <FormattedMessage {...messages.ImsNewPasswordButtonSetPassword} />
        </Button>
      </form>
    </FormProvider>
  );
}
